const examEnum = {
  // 考试类型
  ENTRANCE: {
    code: 1,
    name: "ENTRANCE",
    desc: "入学测试",
    kind: "examType"
  },
  WEEK: {
    code: 2,
    name: "WEEK",
    desc: "周测",
    kind: "examType"
  },
  UNIT: {
    code: 3,
    name: "UNIT",
    desc: "单元测试",
    kind: "examType"
  },
  MONTH: {
    code: 4,
    name: "MONTH",
    desc: "月考",
    kind: "examType"
  },
  MIDTERM: {
    code: 5,
    name: "MIDTERM",
    desc: "期中考试",
    kind: "examType"
  },
  END_OF_TERM: {
    code: 6,
    name: "END_OF_TERM",
    desc: "期末考试",
    kind: "examType"
  },
  SIMULATION: {
    code: 7,
    name: "SIMULATION",
    desc: "模拟考试",
    kind: "examType"
  },
  OTHER: {
    code: 8,
    name: "OTHER",
    desc: "其他",
    kind: "examType"
  },

  // 试题类型
  MULTI_CHOICE: {
    code: 0,
    name: "MULTI_CHOICE",
    desc: "多选题",
    kind: "questionType"
  },
  SINGLE_CHOICE: {
    code: 1,
    name: "SINGLE_CHOICE",
    desc: "单选题",
    kind: "questionType"
  },
  SUBJECTIVE: {
    code: 2,
    name: "SUBJECTIVE",
    desc: "主观题",
    kind: "questionType"
  },
  NOT_QUESTION: {
    code: 3,
    name: "NOT_QUESTION",
    desc: "非试题",
    kind: "questionType"
  },

  // 试题类型（制卡）
  CARD_SINGLE_CHOICE: {
    code: 1,
    name: "SINGLE_CHOICE",
    desc: "单选题",
    kind: "cardQuestionType"
  },
  CARD_MULTI_CHOICE: {
    code: 2,
    name: "MULTI_CHOICE",
    desc: "多选题",
    kind: "cardQuestionType"
  },
  CARD_SUBJECTIVE: {
    code: 3,
    name: "SUBJECTIVE",
    desc: "主观题",
    kind: "cardQuestionType"
  },

  // 答案确认状态
  NONE: {
    code: 0,
    name: "NONE",
    desc: "无",
    kind: "standConfirm"
  },
  PENDING_CONFIRM: {
    code: 1,
    name: "PENDING_CONFIRM",
    desc: "未确认",
    kind: "standConfirm"
  },
  CONFIRMED: {
    code: 2,
    name: "CONFIRMED",
    desc: "已确认",
    kind: "standConfirm"
  },

  // 批阅状态
  NOT_GRADING: {
    code: 1,
    name: "NOT_GRADING",
    desc: "未批阅",
    kind: "gradingStatus"
  },
  GRADING: {
    code: 2,
    name: "GRADING",
    desc: "批阅",
    kind: "gradingStatus"
  },
  PAUSE_GRADING: {
    code: 3,
    name: "PAUSE_GRADING",
    desc: "暂停批阅",
    kind: "gradingStatus"
  },
  GRADING_DONE: {
    code: 4,
    name: "GRADING_DONE",
    desc: "结束批阅",
    kind: "gradingStatus"
  },

  // 考试范围
  SCHOOL: {
    code: 0,
    name: "SCHOOL",
    desc: "单校",
    kind: "examScope"
  },
  MULIT_SCHOOLS: {
    code: 1,
    name: "MULIT_SCHOOLS",
    desc: "学校联考",
    kind: "examScope"
  },
  REGION: {
    code: 2,
    name: "REGION",
    desc: "区域联考",
    kind: "examScope"
  },

  // 是否有痕
  NON_WRITING: {
    code: 0,
    name: "NON_WRITING",
    desc: "网络阅卷",
    kind: "markingType"
  },
  WRITING: {
    code: 1,
    name: "WRITING",
    desc: "有痕阅卷",
    kind: "markingType"
  },

  // 试卷类型
  A4: {
    code: 1,
    name: "A4",
    desc: "A4",
    kind: "paperType"
  },
  A3: {
    code: 1,
    name: "A3",
    desc: "A3",
    kind: "paperType"
  },

  //
  SEALING_LINE_FILLING: {
    code: 1,
    name: "SEALING_LINE_FILLING",
    desc: "密封线填涂",
    kind: "studCoordinateType"
  },
  SEALING_LINE_QR_CODE: {
    code: 2,
    name: "SEALING_LINE_QR_CODE",
    desc: "密封线二维码",
    kind: "studCoordinateType"
  },
  CLASS_STUD_NO: {
    code: 3,
    name: "CLASS_STUD_NO",
    desc: "班级学号填涂",
    kind: "studCoordinateType"
  },
  EXAM_NO: {
    code: 4,
    name: "EXAM_NO",
    desc: "考号填涂",
    kind: "studCoordinateType"
  },
  QR_CODE: {
    code: 5,
    name: "QR_CODE",
    desc: "二维码",
    kind: "studCoordinateType"
  },
  BAR_CODE: {
    code: 6,
    name: "BAR_CODE",
    desc: "条形码/二维码",
    kind: "studCoordinateType"
  },

  // 是否公开
  SELF: {
    code: 0,
    name: "SELF",
    desc: "管理员和自己可见",
    kind: "openStatus"
  },
  OPEN: {
    code: 1,
    name: "OPEN",
    desc: "公开",
    kind: "openStatus"
  },

  // 导入类型
  COMMON: {
    code: 0,
    name: "COMMON",
    desc: "普通考试",
    kind: "importType"
  },
  IMPORT: {
    code: 1,
    name: "IMPORT",
    desc: "导入考试",
    kind: "importType"
  },
  ONLINE: {
    code: 2,
    name: "ONLINE",
    desc: "在线考试",
    kind: "importType"
  },
  SHEET: {
    code: 3,
    name: "SHEET",
    desc: "制卡考试",
    kind: "importType"
  },

  // 高考区域
  JIANG_SU:{
    code: 1,
    name: "JIANG_SU",
    desc: "江苏",
    kind: "gaokaoArea"
  },
  ZHE_JIANG:{
    code: 2,
    name: "ZHE_JIANG",
    desc: "浙江",
    kind: "gaokaoArea"
  },
  SHANG_HAI:{
    code: 3,
    name: "SHANG_HAI",
    desc: "上海",
    kind: "gaokaoArea"
  },
  SHAN_DONG:{
    code: 4,
    name: "SHAN_DONG",
    desc: "山东",
    kind: "gaokaoArea"
  },
  BEI_JING:{
    code: 5,
    name: "BEI_JING",
    desc: "北京",
    kind: "gaokaoArea"
  },
  TIAN_JIN:{
    code: 6,
    name: "TIAN_JIN",
    desc: "天津",
    kind: "gaokaoArea"
  },
  HE_NAN:{
    code: 7,
    name: "HE_NAN",
    desc: "河南",
    kind: "gaokaoArea"
  },

  // 考试线性类型
  RATE:{
    code :1,
    name: "RATE",
    desc: "比例",
    kind: "examLineType"
  },
  SCORE:{
    code : 2,
    name: "SCORE",
    desc: "分数",
    kind: "examLineType"
  },
  STUDENT_COUNT:{
    code :3,
    name: "STUDENT_COUNT",
    desc: "人数",
    kind: "examLineType"
  },

  // 考试等级类型
  FIVE:{
    code:1,
    name: "FIVE",
    desc:"5档",
    kind: "examLevelType"
  },
  EIGHT:{
    code:2,
    name: "EIGHT",
    desc:"8档",
    kind: "examLevelType"
  },
  ELEVEN:{
    code:3,
    name: "ELEVEN",
    desc:"11档",
    kind: "examLevelType"
  },
  TWENTY_ONE:{
    code:4,
    name: "TWENTY_ONE",
    desc:"21档",
    kind: "examLevelType"
  },

  // 是否参加统计
  NO_ABSENT:{
    code :0,
    name: "NO_ABSENT",
    desc:"参加统计",
    kind: "AbsentStatus"
  },
  ABSENT:{
    code :1,
    name: "ABSENT",
    desc:"不参加统计",
    kind: "AbsentStatus"
  },

  PLUS:{
    code :1,
    name: "PLUS",
    desc:"加分",
    kind: "ScoreFlag"
  },
  MINUS:{
    code :2,
    name: "MINUS",
    desc:"减分",
    kind: "ScoreFlag"
  },

  // 是否存在试卷
  NO_PAPER: {
    code: 1,
    name: "NO_PAPER",
    desc: "无试卷",
    kind: "hasPaper"
  },
  HAS_PAPER: {
    code: 2,
    name: "HAS_PAPER",
    desc: "有试卷",
    kind: "hasPaper"
  },
  PAPER_ERROR: {
    code: 3,
    name: "PAPER_ERROR",
    desc: "试卷错误",
    kind: "hasPaper"
  },
  NO_POINT:{
    code: 1,
    name: "NO_POINT",
    desc: "未切题",
    kind: "hasStand"
  },
  HAS_POINT:{
    code: 2,
    name: "HAS_POINT",
    desc: "已切题",
    kind: "hasStand"
  },
  YES:{
    code :1,
    name: "YES",
    desc:"是",
    kind: "Bool"
  },
  NO:{
    code :0,
    name: "NO",
    desc:"否",
    kind: "Bool"
  },
}

function keyObject (key) {
  return examEnum[key]
}

function enumArray (type, kind) {
  const keys = Object.keys(examEnum)
  const list = []
  for (let index = 0; index < keys.length; index++) {
    const key = keys[index];
    const { code, name, desc, kind } = keyObject(key)
    if (type !== kind) continue
    list.push({ code, name, desc, key })
  }
  return list
}

function isExist (key) {
  const target = keyObject(key)
  if (target) {
    return true
  } else {
    return false
  }
}

// 如果value2枚举的整型和字符串有一个形式命中，就认为相等
function equals (emun, value2) {
  if (emun) {
    return emun.code === value2 || emun.name === value2
  } else {
    console.debug('emun is not exist')
    return false
  }
}

function getKeyByValue (value, kind) {
  return Object.keys(examEnum).find(key => {
    const emun = keyObject(key)
    if (emun) {
      return emun.code === value && emun.kind === kind
    }
  });
}

function getCodeByKey (key) {
  let object = keyObject(key)
  if (object) {
    return object.code
  }
  return -1
}

function getDescByKey (key) {
  let object = keyObject(key)
  if (object) {
    return object.desc
  }
  return ""
}

const targetObject = {
  isExist,
  equals,
  enumArray,
  getKeyByValue,
  getCodeByKey,
  getDescByKey,
  examEnum
}

const keys = Object.keys(examEnum)
for (let index = 0; index < keys.length; index++) {
  const key = keys[index];
  if (targetObject[key]) continue
  targetObject[key] = Object.freeze(keyObject(key))
}

export default Object.freeze(targetObject)